import { useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router'
import { Menu, X } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false)
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20)
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const navLinks = [
        { name: 'Início', href: '/' },
        { name: 'Violência contra Pessoas LGBTI+', href: '/ViolenciaContraPessoasLGBTI' },
        { name: 'Consequências e Impacto', href: '/ConsequenciaImpacto' },
        { name: 'O Apoio da APAV', href: '/ApoioAPAV' },
        { name: 'Direitos', href: '/Direitos' },
        { name: 'Informações Úteis', href: '/infoUteis' },
    ]

    return (
        <nav
            className={`fixed w-full top-0 z-50 transition-all duration-500 ${scrolled
                    ? 'bg-white/95 backdrop-blur-xl shadow-lg border-b border-slate-200'
                    : 'bg-white/95 backdrop-blur-xl border-b border-slate-200'
                }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex justify-between items-center h-20 lg:h-28">
                    {/* Logo */}
                    <div className="flex-shrink-0">
                        <Link to="/" className="hover:opacity-90 transition-opacity">
                            <img
                                src="/assets/images/lgbt-1.png"
                                alt="APAV LGBTI+"
                                className={`transition-all duration-300 ${scrolled ? 'h-14 lg:h-16' : 'h-16 lg:h-20'
                                    }`}
                            />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden lg:block">
                        <div className="ml-10 flex items-center space-x-6">
                            {navLinks.map((link) => (
                                <NavLink
                                    key={link.name}
                                    to={link.href}
                                    end={link.href === '/'}
                                    className={({ isActive }) =>
                                        `px-1 py-2 text-sm font-bold transition-all whitespace-nowrap border-b-2 ${isActive
                                            ? 'text-brand-700 border-brand-700'
                                            : 'text-slate-700 border-transparent hover:text-brand-700 hover:border-brand-700'
                                        }`
                                    }
                                >
                                    {link.name}
                                </NavLink>
                            ))}
                        </div>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="lg:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="p-2 rounded-md text-slate-700"
                            aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
                        >
                            {isOpen ? <X size={28} /> : <Menu size={28} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Navigation */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        className="lg:hidden glass border-t border-slate-100 overflow-hidden bg-white"
                    >
                        <div className="px-4 pt-2 pb-6 space-y-1 max-h-[80vh] overflow-y-auto">
                            {navLinks.map((link) => (
                                <NavLink
                                    key={link.name}
                                    to={link.href}
                                    end={link.href === '/'}
                                    className={({ isActive }) =>
                                        `block px-4 py-4 text-lg font-bold border-b border-slate-100 active:bg-slate-50 transition-colors ${isActive ? 'text-brand-700 bg-slate-50' : 'text-slate-800'
                                        }`
                                    }
                                    onClick={() => setIsOpen(false)}
                                >
                                    {link.name}
                                </NavLink>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </nav>
    )
}
